import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UrlAddressService } from 'src/app/core/services/url-address/url-address.service';

@Component({
    selector: 'smart-router-link',
    templateUrl: './smart-router-link.component.html',
    styleUrls: ['./smart-router-link.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterModule],
})
export class SmartRouterLinkComponent implements OnInit {
    private _urlAddress = inject(UrlAddressService);

    @Input() isRouterLink: boolean = false;
    @Input() queryParams: object = {};
    @Input() ariaLabel: string | undefined;

    public externalLink: string = '';
    private _link: string | undefined;

    @Input() set link(link: string | undefined) {
        this._link = link;
        this._setExternalLink();
    }
    get link(): string {
        return this._link || '';
    }
    ngOnInit(): void {
        if (this.isRouterLink === undefined) {
            this.isRouterLink = false;
        }
        if (this.link?.includes('?') && this.queryParams) {
            //remove query params from link
            this.link = this.link.split('?')[0];
        }
    }

    private _setExternalLink(): void {
        this.externalLink = this._urlAddress.getExternalLink(this.link, this.queryParams);
    }
}
